<template>
  <modal content-class="marketing-email-config-modal"
         :title="$t('message.email.message.emailSettings')"
         :value="showing"
         :closeable="false"
         @input="emitShowing">

    <app-form @submit="saveEmail">
      <stepper-section :label="$t('message.marketingGenerics.message.content')">
        <text-field class="marketing-email-config-modal-text"
                    v-model="title"
                    :label="$t('message.marketingGenerics.message.title')"
                    name="Título"
                    :help="$t('message.email.message.tooltipEmailName')"
                    validate="required" />

        <text-field class="marketing-email-config-modal-text"
                    v-model="subject"
                    :label="$t('message.email.message.subject')"
                    name="Assunto"
                    :help="$t('message.email.message.tooltipEmailSubject')"
                    :text="`${this.$t('message.email.message.subjectLength1')} ${subject ? subject.length : 0} ${this.$t('message.email.message.subjectLength2')}`"
                    validate="required|max:60" />

        <button-toggle v-if="loaded"
                       :label=" { opened: this.$t('message.generics.message.advancedSettings'), closed: this.$t('message.generics.message.advancedSettings') }"
                       :start-opened="!!brief">
          <text-field class="marketing-email-config-modal-text"
                      v-model="brief"
                      :label="this.$t('message.email.message.textPreview')"
                      name="Prévia do texto"
                      :help="this.$t('message.email.message.tooltipTextPreview')" />

        </button-toggle>
      </stepper-section>

      <stepper-section :label="this.$t('message.email.message.senderData')">
        <text-field class="marketing-email-config-modal-text"
                    v-model="senderName"
                    :label="this.$t('message.email.message.senderName')"
                    name="Nome do remetente"
                    :help="this.$t('message.email.message.tooltipSenderName')"
                    validate="required" />

        <text-field class="marketing-email-config-modal-text"
                    v-model="senderEmail"
                    :label="this.$t('message.email.message.senderEmail')"
                    name="E-mail do remetente"
                    :help="this.$t('message.email.message.tooltipSenderEmail')"
                    :text="this.$t('message.email.message.validEmailWarning')"
                    validate="required" />
      </stepper-section>

      <div class="marketing-email-config-modal-actions">
        <app-button v-if="hasBackButton"
                    :label="$t('message.email.message.previous')"
                    outline
                    @click="emitBack"></app-button>

        <button class="btn btn-round btn-primary "
                type="submit">{{$t('message.generics.message.save')}}</button>
      </div>

    </app-form>
  </modal>
</template>

<script>
import ButtonToggle from "@/components/generic/button/toggle/ButtonToggle";
import AppButton from "@/components/generic/button/Button";
import EventBus from "@packages/event-bus";
import StepperSection from "@components/StepperSection";
import TextField from "@components/form/TextField.vue";
import AppForm from "@components/form/Form.vue";
import Modal from "@components/generic/Modal.vue";
import { cloneDeep } from "lodash";

export default {
  components: {
    AppButton,
    Modal,
    AppForm,
    TextField,
    StepperSection,
    ButtonToggle,
  },

  props: {
    showing: {
      type: Boolean,
      default: false,
    },
    closeable: {
      type: Boolean,
      default: true,
    },
    item: {
      type: Object,
      required: false,
    },
    hasBackButton: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  watch: {
    showing(value) {
      if (value) {
        this.setInitialData();
      }
    },
  },

  data() {
    return {
      senderEmail: undefined,
      senderName: undefined,
      brief: undefined,
      subject: undefined,
      title: undefined,
      isAutomationFlow: false,
      content: {
        htmlContent: undefined,
        cssStyle: undefined,
        editorType: undefined,
        compiledHtml: undefined,
      },
      loaded: false,
    };
  },

  methods: {
    emitBack() {
      this.$emit("back");
    },
    emitShowing(showing) {
      this.$emit("update:showing", showing);
    },
    emitInput(key, value) {
      const newVal = cloneDeep(this.value);

      newVal[key] = value;

      this.$emit("input", newVal);
    },
    async saveEmail() {
      if (this.isEdit) {
        const updatedEmail = await this.$api.marketing.email.message.edit({
          emailId: this.item.id,
          data: {
            senderEmail: this.senderEmail,
            senderName: this.senderName,
            brief: this.brief,
            subject: this.subject,
            title: this.title,
            isAutomationFlow: this.isAutomationFlow,
            cssStyle: this.content.cssStyle,
            rawContent: this.content.htmlContent,
            editorType: this.content.editorType,
          },
        });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t('message.successMessages.message.emailUpdated'),
          timeout: 3000,
        });

        this.$emit("saved", updatedEmail);
      } else {
        const createdEmail = await this.$api.marketing.email.message.create({
          senderEmail: this.senderEmail,
          senderName: this.senderName,
          brief: this.brief,
          subject: this.subject,
          title: this.title,
          isAutomationFlow: this.isAutomationFlow,
          rawContent: this.content.htmlContent,
          cssStyle: this.content.cssStyle,
          editorType: this.content.editorType,
        });        

        this.$emit("saved", createdEmail);
      }
    },
    setInitialData() {
      if (this.item) {
        this.senderName = this.item.senderName;
        this.senderEmail = this.item.senderEmail;
        this.title = this.item.title;
        this.isAutomationFlow = this.item.isAutomationFlow;
        this.subject = this.item.subject;
        this.brief = this.item.brief;

        this.content.htmlContent = this.item.rawContent;
        this.content.cssStyle = this.item.cssStyle;
        this.content.compiledHtml = this.item.content;
        this.content.editorType = this.item.editorType;
      } else {
        const loggedUser = this.$store.state.users.user;

        this.senderName = loggedUser.nome;
        this.senderEmail = "marketing@wifeed-mail.com.br";

        const dataInSessioStorage = JSON.parse(sessionStorage.getItem("email_data"));
        const data = this.$store.state.marketing.email.create.data.title ? this.$store.state.marketing.email.create.data : dataInSessioStorage;


        this.title = data.title;
        this.isAutomationFlow = data.isAutomationFlow;
        this.content =  data.model;
      }
    },    
  },

  computed: {
    isEdit() {
      return !!this.item;
    },
  },

  mixins: [],

  mounted() {
    this.setInitialData();
    this.loaded = true;
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-config-modal {
  .marketing-email-config-modal-text {
    margin-bottom: 0;
    padding-top: 15px;
  }

  .marketing-email-config-modal-actions {
    display: flex;
    justify-content: center;
    gap: 25px;
  }
}
</style>
